import React, { useState } from 'react'

import { observer } from 'mobx-react'
import { useNavigate } from 'react-router-dom'

import ButtonIcon from 'components/ButtonIcon'

import { useStore } from 'store'

import { default as WidgetSettingsModal } from '../../containers/Widgets/WidgetSettings'

import styles from './styles.module.scss'

interface IProps {}

//Resize
const UserWidgetSettings: React.FC<IProps> = observer(() => {
  const { profile } = useStore()
  const navigate = useNavigate()

  // const navigateToWidgetSettings = () => {
  //   navigate('/widget/settings')
  // }

  const [isOpenWidgetSettingsModal, setIsOpenWidgetSettingsModal] =
    useState(false)

  const openWidgetSettingsModal = () => {
    setIsOpenWidgetSettingsModal(true)
  }

  const onChangeOpenWidgetSettingsModal = (value: boolean) => {
    setIsOpenWidgetSettingsModal(value)
  }

  if (!profile.selectedUser.Activated) return null

  return (
    <div className={styles.container}>
      <div className={styles.titleBlock}>
        <div className={styles.title}>Widget Settings</div>
        <ButtonIcon icon={'edit'} onClick={openWidgetSettingsModal} />
      </div>

      {isOpenWidgetSettingsModal ? (
        <WidgetSettingsModal
          isOpen={isOpenWidgetSettingsModal}
          setIsOpen={onChangeOpenWidgetSettingsModal}
        />
      ) : null}
    </div>
  )
})

UserWidgetSettings.displayName = 'UserWidgetSettings'

export default UserWidgetSettings
